import { Component, OnInit, AfterContentInit, ElementRef } from "@angular/core";
import { SvcServices, windowService, ContentService } from "app/services";
import { PopupModalService } from "app/services/popup-modal.service";
import { GuidService } from "app/services/guid.service";

@Component({
  selector: "popup-site-info",
  templateUrl: "./popup-site-info.component.html"
})
export class PopupSiteInfoComponent implements OnInit, AfterContentInit {
  infoContent: any;
  ariaDescribedBy: string;
  ariaTitleId: string;
  ariaBodyId: string;
  window: any;

  constructor(
    private guidService: GuidService,
    private popupModalService: PopupModalService,
    private _window: windowService,
    private _contentService: ContentService,
    private el: ElementRef
  ) {
    this.window = _window.nativeWindow;
  }

  ngOnInit() {
    this._contentService.modal_content.subscribe((mData)=> {
        if(mData !== null && mData !== undefined){
          if((mData.content && mData.content.CARDS) || (mData.value) ){
            this.infoContent = (mData.value) ? mData.value.content.CARDS : mData.content.CARDS;

          setTimeout(() => {
            const ele = this.el.nativeElement.querySelector('a[href="#"]');
            try {
              if (ele) {
                ele.addEventListener("click", evt => {
                  evt.preventDefault();
                  this.continue();
                });
              } else {
                throw "HTML element missing";
              }
            } catch (e) {
              console.log(e);
            }
          }, 500);
        }
      }
    });
  }

  ngAfterContentInit() {
    this.ariaTitleId = this.guidService.getSimpleGuid();
    this.ariaBodyId = this.guidService.getSimpleGuid();
    this.ariaDescribedBy = this.ariaTitleId + ' ' + this.ariaBodyId;
  }

  continue() {
    this.cancel();
    this.window.sessionStorage.setItem("next_screen", "#newsecuremessage");
  }

  cancel() {
    this.popupModalService.closePopupContent.emit();
  }
}
